import React from 'react';
import Context from '../Utilities';

const { Fragment } = window.wp.element;

function Compare() {
    const types = [
        {
            id: 'ApproveShare',
            name: 'Approves of Trump, would share',
            description:
                'You are among the 57% of Trump approvers who would choose to share their opinion of him among a group of people discussing how much they dislike Trump. A smaller share of Trump <em>disapprovers</em> say they would speak up among people discussing their <em>positive</em> views of him.',
            share: 'would',
        },
        {
            id: 'DisapproveShare',
            name: 'Disapproves of Trump, would share',
            description:
                'You are among the 43% of Trump disapprovers who would choose to share their opinion of him among a group of people discussing how much they like Trump. A larger share of Trump <em>approvers</em> say they would speak up among people discussing their <em>negative</em> views of him.',
            share: 'would',
        },
        {
            id: 'ApproveNotShare',
            name: 'Approves of Trump, would not share',
            description:
                'You are among the 43% of Trump approvers who would choose to avoid sharing their opinion of him among a group of people discussing how much they dislike Trump. A larger share of Trump <em>disapprovers</em> say they would not share their views among people discussing their <em>positive</em> views of him.',
            share: 'would not',
        },
        {
            id: 'DisapproveNotShare',
            name: 'Disapproves of Trump, would not share',
            description:
                'You are among the 57% of Trump disapprovers who would choose to avoid sharing their opinion of him among a group of people discussing how much they like Trump. A smaller share of Trump <em>approvers</em> say they would not share their views among people discussing their <em>negative</em> views of him.',
            share: 'would not',
        },
        {
            id: null,
            name: 'null',
            description: '',
            share: 'would',
        },
    ];

    function createMarkup(thisType) {
        return {
            __html: thisType.description,
        };
    }

    return (
        <Context.Consumer>
            {({ type, why, share, approval }) => {
                const newWhy = why.charAt(0).toUpperCase() + why.slice(1);
                const img = `https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Would${share}Reasons/Would${share}Reasons_${newWhy}${approval}.png`;
                const mobile_img = `https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Would${share}Reasons_Mobile/Would${share}Reasons_Mobile_${newWhy}${approval}.png`;
                const description = types
                    .filter(function(thisType) {
                        if (thisType.id === type) {
                            return true;
                        }
                        return false;
                    })
                    .map(thisType => (
                        <Fragment>
                            <div id="compareBar">
                                <p>
                                    The public is divided: 48% of U.S. adults
                                    say they would share their views of Trump
                                    with those who disagree, while 51% would
                                    not.{' '}
                                    <span
                                        dangerouslySetInnerHTML={createMarkup(
                                            thisType,
                                        )}
                                    />
                                </p>
                                <img
                                    src="https://assets.pewresearch.org/interactives/politics/2019/dinner-party/ApproveDisapproveChart.png"
                                    alt="A bar chart showing Americans who approve and disapprove of Trump and of those, which percentage would share their opinions at a dinner party with people of opposing views."
                                />
                            </div>
                            <p>
                                Interestingly, both approvers and disapprovers
                                of Trump cite similar reasons why they{' '}
                                {thisType.share} speak up:
                            </p>
                        </Fragment>
                    ));
                return (
                    <div id="compare">
                        <p className="subhead">
                            So how do you compare to other Americans?
                        </p>
                        {description}
                        <div id="bar" className={`${share} bar_desk`}>
                            <img
                                src={`${img}`}
                                alt="A bar chart comparing the user's approval and reasons for sharing or not sharing to other Americans."
                            />
                        </div>
                        <div id="bar" className={`${share} bar_mobile`}>
                            <img
                                src={`${mobile_img}`}
                                alt="A bar chart comparing the user's approval and reasons for sharing or not sharing to other Americans."
                            />
                        </div>
                    </div>
                );
            }}
        </Context.Consumer>
    );
}

export default Compare;
